export default (axios, baseURL) => async (sid, vendorSid, oauthSignature) => {
  const url = `/v1/clients/${sid}`;
  const requestParam = {
    'vendor-sid': vendorSid,
    'oauth-signature': oauthSignature
  };
  const axiosConfig = {
    method: 'GET',
    baseURL,
    url,
    params: requestParam
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  if (axiosResponse.data.data.length === 0) {
    throw new Error('Client not found');
  }
  const client = axiosResponse.data.data[0];

  return client;
};
